// extracted by mini-css-extract-plugin
export default {"list":"aJCcYW","listWithMargin":"bJCcYW"};